import React from 'react';

import { ChevronDownIcon } from '@adsk/alloy-react-icon';
import theme, { StylableComponent } from '@adsk/alloy-react-theme';

type ToggleButtonProps = StylableComponent<HTMLDivElement> & {
  isOpen: boolean;
  disabled?: boolean;
};

const ToggleIcon = ({ style, isOpen, ...props }: ToggleButtonProps) => {
  return (
    <div
      data-testid={'DatePicker__toggle'}
      style={{
        display: 'flex',
        padding: 0,
        cursor: props.disabled ? 'not-allowed' : undefined,
        marginLeft: 'auto',
      }}
      {...props}
    >
      <ChevronDownIcon
        style={[
          {
            color: theme.tokens.colors.icon.secondary.value,
            ...(isOpen && {
              transform: 'rotate(180deg)',
            }),
          },
          style,
        ]}
      />
    </div>
  );
};

export default ToggleIcon;
